import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PositionsService } from '../../../units/services/positions.service';
import { catchError, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getPositions } from '../actions/positions.actions';
import { getPositionsFailure, getPositionsSuccess } from '../actions/positions-api.actions';
import { Position } from '../../../units/models/position';

@Injectable()
export class PositionsEffects {

  getPositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPositions),
      // exhaustMap (not switchMap): the position websocket hub re-dispatches
      // getPositions on (re)connect. switchMap would cancel an in-flight initial
      // load, leaving areLoading=true forever. exhaustMap ignores re-dispatches
      // while a request is running; live updates still arrive via updatePositions.
      exhaustMap((action: any) => this.positionService.getPositions(action.unitIds)
        .pipe(
          exhaustMap(positions => {
            positions?.forEach(p => Position.calculateStatus(p));
            return of(getPositionsSuccess({positions: positions}));
          }),
          catchError(error => of(getPositionsFailure({error})))
        )
      )
    )
  );

  persistPositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPositionsSuccess),
      tap((action) => {
        try {
          localStorage.setItem(`${environment.storagePrefix}.cachedPositions`, JSON.stringify(action.positions));
        } catch { }
      })
    ), { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private positionService: PositionsService,
  ) { }
}
